import { render, staticRenderFns } from "./project-loader.vue?vue&type=template&id=4a0b8258&scoped=true"
import script from "./project-loader.vue?vue&type=script&lang=ts"
export * from "./project-loader.vue?vue&type=script&lang=ts"
import style0 from "./project-loader.vue?vue&type=style&index=0&id=4a0b8258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0b8258",
  null
  
)

export default component.exports